function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_2097",
  "data-name": "Path 2097",
  d: "M.929,8.75A7.7,7.7,0,0,0,3.275,14.4,7.7,7.7,0,0,0,8.929,16.75,7.706,7.706,0,0,0,14.583,14.4,7.705,7.705,0,0,0,16.929,8.75,7.708,7.708,0,0,0,14.583,3.1,7.708,7.708,0,0,0,8.929.75,7.706,7.706,0,0,0,3.275,3.1,7.706,7.706,0,0,0,.929,8.75ZM13.718,3.961A6.525,6.525,0,0,1,15.7,8.75a6.529,6.529,0,0,1-1.615,4.385L4.621,3.519A6.623,6.623,0,0,1,8.929,1.981,6.525,6.525,0,0,1,13.718,3.961Zm-.481,10.019a6.62,6.62,0,0,1-4.308,1.538,6.521,6.521,0,0,1-4.788-1.981A6.522,6.522,0,0,1,2.16,8.75,6.532,6.532,0,0,1,3.775,4.365Z",
  transform: "translate(-0.929 -0.75)",
  fillRule: "evenodd"
});

var SvgBlock = function SvgBlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/block.e07f5f9b.svg";
export { ForwardRef as ReactComponent };